// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a514b711","239":"0dcfcd67","732":"57ac8bca"}[chunkId] + ".chunk.js";
};